import script from "./SecondaryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryPage.vue?vue&type=script&setup=true&lang=js"

import "./SecondaryPage.vue?vue&type=style&index=0&id=1dbedb52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbedb52"]])

export default __exports__